import styled from 'styled-components';

export const Value = styled('text')`
  ${({ theme }) => theme.typography.tiny}
  fill: ${({ theme }) => theme.color.whiteRGBA(0.5)};
`;

export const LabelWrapper = styled('svg')`
  overflow: visible;
`;
